/**
 * Enveloppe de section pour les grilles tarifaires — titre, chapô, tableau.
 *
 * Mutualise le markup entre les trois grilles (transferts, mise à disposition,
 * location) pour qu'elles s'intègrent de façon homogène dans les hubs, et pour
 * qu'un `<h2>` porte bien chaque tableau (structure de titres exploitée par
 * Google et les moteurs de réponse).
 *
 * Composant serveur, classes logiques (RTL-safe).
 */
type PricingSectionProps = {
  eyebrow: string;
  heading: string;
  intro?: string;
  /** `id` d'ancrage pour les liens internes (« voir les tarifs »). */
  anchorId?: string;
  surface?: "plain" | "tinted";
  children: React.ReactNode;
};

export function PricingSection({
  eyebrow,
  heading,
  intro,
  anchorId,
  surface = "plain",
  children,
}: PricingSectionProps): JSX.Element {
  return (
    <section
      id={anchorId}
      className={`py-12 md:py-16 ${surface === "tinted" ? "bg-black/[0.02]" : "bg-white"}`}
    >
      <div className="mx-auto max-w-[90rem] px-6 md:px-8">
        <p className="text-xs uppercase tracking-[0.22em] text-primary">
          {eyebrow}
        </p>
        <h2 className="mt-3 font-space-age text-xl tracking-[0.16em] md:text-2xl">
          {heading}
        </h2>
        {intro ? (
          <p className="mt-4 max-w-3xl text-base leading-relaxed text-black/75">
            {intro}
          </p>
        ) : null}
        <div className="mt-7">{children}</div>
      </div>
    </section>
  );
}

export default PricingSection;
